namespace advisorop.domains {

    export interface IAlertLog {
        id?: number;        
        alertMessage?: string;
        severityDescription?: string;
        applicationDescription?: string;
        alertDescription?: string;
        status?: string;        
        dateCreated?: Date;
        dateRead?: Date;
        statusDescription?: string;
        dateArchived?: Date;
        doneActionTitle?: string;
        dateDeleted?: Date;        
        applicationId?: number;
        severityId?: number;
        systemUserCreatedName?: string;
        severityLevel?: number;
        alertTypeId?: number;
        alertSubType?: AlertSubType;
        relatedHouseholdId?: number;
        relatedInvestorId?: number;
        relatedAccountId?: number;
        relatedAccountGroupId?: number;
        alertUrl?: Array<IAlertUrl>;
        relatedAdvisorId?: number;
        advisors?: Array<domains.IAdvisor>;
        relatedHouseholds?: string;
        relatedInvestors?: string;
        relatedAccount?: string;
        relatedAccountNumber?: string;
        relatedServicerId?: string;
        relatedServicer?: string;
        accounts?: string;
        households?: string;
        investors?: string;
    }

    export class AlertLog implements IAlertLog {

    }

    export interface IAlertCounters {
        numberOfUsertEntryTasks?: number;
        numberOfAllAlerts?:number;
        numberOfWfTasks?:number;
        numberOfRmTasks?: number;
    }

    export interface IAlert {
        id: number;
        applicationModuleId: ApplicationModules;
        severityId: AlertSeverity;
        alertTypeId: AlertType;
        message: string;
    }

    export interface IAlertUrl {
        caption: string;
        url: string;
    }
}